import type {
  AudioFileSource,
  RecordingSource,
} from '@/features/media-file/domain/models/media-file'

export const isRecordingSource = (
  source: AudioFileSource
): source is RecordingSource =>
  source.kind === 'recording' && 'file' in source && source.file instanceof File
